import { handleActions } from 'redux-actions';

import { types, inputFieldNames } from '../constants';

const INITIAL_STATE = {
  newCompany: {
    showCreateCompanyDialog: false,
    showEditCompanyDialog: false,
    item: {},
    isSaving: false,
    errorMessage: ''
  },
  company: {
    item: null,
    isLoading: false,
    errorMessage: ''
  },
  deleteOrDeactivatingCompany: {
    open: false,
    isSaving: false,
    companyId: 0,
    errorMessage: '',
    status: 0,
    item: {}
  }
};

const openCreateCompanyDialog = (state, { open }) => {
  return {
    ...state,
    newCompany: {
      ...state.newCompany,
      showCreateCompanyDialog: open,
      item: {}
    }
  };
};

const openEditCompanyDialog = (state, { open }) => {
  return {
    ...state,
    newCompany: {
      ...state.newCompany,
      showEditCompanyDialog: open,
      item: {}
    }
  };
};

const inputChangeCreateEditCompanyForm = (state, { value, inputFieldName }) => {
  const company = { ...state.newCompany.item };
  if (inputFieldName === inputFieldNames.NAME) {
    company.name = value;
  } else if (inputFieldName === inputFieldNames.EMAIL) {
    company.email = value;
  } else if (inputFieldName === inputFieldNames.PHONE) {
    company.phone = value;
  }

  return {
    ...state,
    newCompany: {
      ...state.newCompany,
      item: company
    }
  };
};

const startSubmitCompany = (state) => {
  return {
    ...state,
    newCompany: {
      ...state.newCompany,
      isSaving: true
    }
  };
};
const submitCompanySuccess = (state, { submittedCompany }) => {
  return {
    ...state,
    company: {
      ...state.company,
      item: submittedCompany
    }
  };
};
const submitCompanyFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newCompany: {
      ...state.newCompany,
      errorMessage
    }
  };
};
const submitCompanyFinished = (state) => {
  return {
    ...state,
    newCompany: {
      ...state.newCompany,
      isSaving: false
    }
  };
};

const editCompany = (state, { company }) => {
  return {
    ...state,
    newCompany: {
      ...state.newCompany,
      item: company
    }
  };
};

function showDeleteOrDeactiveCompanyDialog(state, { open, companyId, status }) {
  return {
    ...state,
    deleteOrDeactivatingCompany: {
      ...state.deleteOrDeactivatingCompany,
      open,
      errorMessage: '',
      companyId,
      isSaving: false,
      status
    }
  };
}

//Handles the incoming actions.
export default handleActions(
  {
    [types.OPEN_CREATE_COMPANY_DIALOG]: openCreateCompanyDialog,
    [types.OPEN_EDIT_COMPANY_DIALOG]: openEditCompanyDialog,

    [types.INPUT_CHANGE_CREATE_COMPANY_FORM]: inputChangeCreateEditCompanyForm,

    [types.DEACTIVATE_OR_DELETE_COMPANY_DIALOG]: showDeleteOrDeactiveCompanyDialog,

    [types.START_SUBMIT_COMPANY]: startSubmitCompany,
    [types.SUBMIT_COMPANY_SUCCESS]: submitCompanySuccess,
    [types.SUBMIT_COMPANY_FAILURE]: submitCompanyFailure,
    [types.SUBMIT_COMPANY_FINISHED]: submitCompanyFinished,

    [types.EDIT_COMPANY]: editCompany
  },
  INITIAL_STATE
);
